import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TApiPaginatedResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetAccrualPoliciesWorkersRequestSchema,
  TGetAccrualPoliciesWorkersResponseSchema,
} from "./getAccrualPoliciesWorkers.schema";

export const getAccrualPoliciesWorkers = (axios: IAxiosInstance) => {
  return async ({
    companyID,
    limit,
    start_at,
    q,
    worker_ids,
  }: TGetAccrualPoliciesWorkersRequestSchema) => {
    const query = new URLSearchParams({ companyID });
    if (limit !== undefined) {
      query.set("limit", String(limit));
    }
    if (start_at !== undefined) {
      query.set("start_at", start_at);
    }

    const { data } = await axios.noRetry.post<
      TApiPaginatedResponse<TGetAccrualPoliciesWorkersResponseSchema>
    >(`/accrual-policies/workers?${query.toString()}`, {
      ...(worker_ids?.length ? { worker_ids } : {}),
      ...(q !== undefined ? { q } : {}),
    });

    if (data.success) {
      return data;
    }

    throw new Error("Something went wrong");
  };
};
